<template>
    <div class="select" @click="toggle()" @blur="toggle(false)">
        <div class="select__visible">
            <div class="select__placeholder">{{title}}</div>
            <div class="select__chosed">{{modelValue >= 0 ? options[modelValue].value : "Выбать"}}</div>
            <div class="select__icon termi-chevron-right"></div>
        </div>
        <div class="select__options" v-show="isToggled">
            <div class="option"
                 v-for="(option, index) in options"
                 :key="index"
                 @click="choose(index)"
            >
                {{option.value}}
            </div>
        </div>
    </div>
</template>

<script>
    export default{
        props: ['modelValue', 'options', 'title'],
        data(){
            return{
                isToggled: false,
            }
        },
        methods: {
            toggle(bool) {
                this.isToggled = bool === undefined ? !this.isToggled : bool
            },
            choose(index){
                this.$emit('update:modelValue', index)
                this.$emit('change', index)
            }
        }
    }
</script>